import { createIcon } from '@chakra-ui/react';

export const DeleteActionIcon = createIcon({
  displayName: 'DeleteActionIcon',
  path: (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        // width="36"
        // height="36"
        viewBox="0 0 36 36"
        fill="none"
      >
        <g clipPath="url(#clip0_2127_34964)">
          <path
            d="M29.1914 6.03166C29.1726 6.03778 22.5868 7.97834 22.5681 7.98473C21.8621 8.23034 21.3877 8.8976 21.3877 9.64509V12.6139C21.3877 13.1964 21.8599 13.6687 22.4425 13.6687H30.4586C31.0412 13.6687 31.5134 13.1964 31.5134 12.6139V7.69659C31.5134 6.49587 30.331 5.64544 29.1914 6.03166Z"
            fill="#FF5E94"
          />
          <path
            d="M11.2617 11.5586V31.4306C11.2617 33.9509 13.3121 36.0013 15.8324 36.0013H26.9426C29.4629 36.0013 31.5133 33.9509 31.5133 31.4306C31.5133 30.3243 31.5133 12.1136 31.5133 11.5586H11.2617Z"
            fill="#9DCFFF"
          />
          <path
            d="M21.3877 11.5586V36.0013H26.9428C29.463 36.0013 31.5135 33.9508 31.5135 31.4306V11.5586H21.3877Z"
            fill="#72BBFF"
          />
          <path
            d="M16.6944 16.4102C16.1119 16.4102 15.6396 16.8824 15.6396 17.4649V30.0942C15.6396 30.6767 16.1119 31.1489 16.6944 31.1489C17.2769 31.1489 17.7492 30.6767 17.7492 30.0942V17.4649C17.7492 16.8824 17.2769 16.4102 16.6944 16.4102Z"
            fill="#5A5A5A"
          />
          <path
            d="M21.3868 16.4102C20.8042 16.4102 20.332 16.8824 20.332 17.4649V30.0942C20.332 30.6767 20.8042 31.1489 21.3868 31.1489C21.9693 31.1489 22.4415 30.6767 22.4415 30.0942V17.4649C22.4415 16.8824 21.9693 16.4102 21.3868 16.4102Z"
            fill="#5A5A5A"
          />
          <path
            d="M22.4415 17.4649V30.094C22.4415 30.6762 21.969 31.1487 21.3867 31.1487V16.4102C21.969 16.4102 22.4415 16.882 22.4415 17.4649Z"
            fill="#444444"
          />
          <path
            d="M26.0792 16.4102C25.4966 16.4102 25.0244 16.8824 25.0244 17.4649V30.0942C25.0244 30.6767 25.4966 31.1489 26.0792 31.1489C26.6617 31.1489 27.1339 30.6767 27.1339 30.0942V17.4649C27.1339 16.8824 26.6617 16.4102 26.0792 16.4102Z"
            fill="#444444"
          />
          <path
            d="M13.5125 1.27216C13.5125 1.27216 13.5125 1.27216 13.5118 1.27216C12.4334 0.598004 10.9794 0.724215 10.0341 1.66943V1.67013L8.09488 3.60864L6.15566 5.54786C5.05879 6.64474 5.05879 8.42927 6.15566 9.52544L7.15059 10.5204L8.57863 10.3727L8.64191 9.02833L7.6477 8.03411C7.37348 7.75989 7.37348 7.31341 7.6477 7.03989L9.58691 5.10068L11.5254 3.16146H11.5261C11.7855 2.90207 12.231 2.87205 12.5196 3.16075L13.5146 4.15568L14.8189 3.93911L15.0066 2.66435C13.9656 1.6233 13.8528 1.48183 13.5125 1.27216Z"
            fill="#5A5A5A"
          />
          <path
            d="M13.5123 1.27221C13.5123 1.27221 13.5123 1.27221 13.5116 1.27221C12.436 0.599743 10.9826 0.721594 10.0339 1.67018L8.09473 3.6087L9.58676 5.10073L11.526 3.16151C11.7851 2.90234 12.2303 2.87154 12.5195 3.16081L13.5144 4.15573L15.0064 2.6644C13.9313 1.58925 13.8701 1.49904 13.5123 1.27221Z"
            fill="#444444"
          />
          <path
            d="M22.3186 2.6091L20.4291 0.719666C19.4696 -0.239889 17.9082 -0.239889 16.9486 0.719666L5.20697 12.4612C4.24742 13.4208 4.24742 14.9821 5.20697 15.9418L7.09641 17.8312C7.50823 18.2431 8.17613 18.2432 8.58802 17.8312L22.3186 4.10071C22.7305 3.68882 22.7305 3.02099 22.3186 2.6091Z"
            fill="#3BA9FF"
          />
          <path
            d="M20.4293 0.719719L22.3188 2.60916C22.7305 3.02084 22.7309 3.68859 22.3188 4.10084L15.4537 10.9659L11.0781 6.59039L16.9488 0.719719C17.9084 -0.239906 19.4697 -0.239906 20.4293 0.719719Z"
            fill="#0081FF"
          />
        </g>
        <defs>
          <clipPath id="clip0_2127_34964">
            <rect width="36" height="36" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </>
  ),
});
